import { createAction } from '@reduxjs/toolkit';
import initialState from './initialState';

export const openPCSModal = createAction('[PhysicianCertificationStatement] openPCSModal');
export const donePCSModal = createAction('[PhysicianCertificationStatement] donePCSModal');

export const reducer = {
  [openPCSModal]: (state, payload) => {
    return {
      ...state,
      open: payload.open,
      context: payload.context || initialState.context,
    };
  },
  [donePCSModal]: (state, payload) => ({
    ...state,
    continue: payload,
  }),
};
